import ManageIcon from './ManageIcon';

export default ManageIcon;
export { ManageIcon };
